// HistorialOptToggle — P3-9b. Franja clicable que abre/cierra el historial de
// optimización. TODA la franja (flecha incluida) es UN solo <button>: cliquear la
// flecha o el texto expande igual, con cursor de mano y accesible por teclado.
import React from 'react';

export default function HistorialOptToggle({ abierto, resumen, onToggle }) {
  return (
    <button type="button" className="pp-opt-hist-tog" onClick={onToggle} aria-expanded={abierto}>
      <span className="pp-opt-hist-arrow" aria-hidden="true">{abierto ? '▴' : '▾'}</span>
      <span>{abierto ? 'Ocultar' : 'Ver historial'} de optimización{resumen ? ` · ${resumen}` : ''}</span>
    </button>
  );
}
